import { _ } from "libs";

import React, { Component } from "react";
import * as Sentry from "@sentry/browser";

const initialState = { hasError: false, eventId: null };
type State = typeof initialState;

export default class ErrorBoundary extends Component<{}, State> {
	state = initialState as State;

	static getDerivedStateFromError(error: Error) {
		return { hasError: true };
	}

	componentDidCatch(error: Error, errorInfo) {
		console.table({ error, errorInfo });
		Sentry.withScope(scope => {
			scope.setExtras(errorInfo);
			const eventId = Sentry.captureException(error);
			this.setState({ eventId });
		});
	}

	render() {
		if (this.state.hasError) {
			<button onClick={() => Sentry.showReportDialog({ eventId: this.state.eventId })}>
				{"errorScreen.button.reportFeedback"}
			</button>;
		}
		return this.props.children;
	}
}
